import React, { useState, useEffect } from 'react';
import { Card } from '../ui/card';

const RideStats = () => {
  const [stats, setStats] = useState({ total: 0, thisMonth: 0, totalSpent: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const api = (await import('../../utils/api')).default;
        const response = await api.get('/rides/my-rides');
        const rides = response.data.rides;
        
        const totalRides = rides.length;
        const totalSpent = rides.reduce((sum, ride) => sum + parseFloat(ride.price || 0), 0);
        
        // Calculate this month's rides
        const now = new Date();
        const thisMonthRides = rides.filter(ride => {
          const rideDate = new Date(ride.timestamp);
          return rideDate.getMonth() === now.getMonth() && 
                 rideDate.getFullYear() === now.getFullYear();
        }).length;
        
        setStats({
          total: totalRides,
          thisMonth: thisMonthRides,
          totalSpent: totalSpent.toFixed(2),
        });
        setLoading(false);
      } catch (error) {
        console.error('Error fetching ride stats:', error);
        setLoading(false);
      }
    };
    
    fetchStats();
  }, []);

  if (loading) {
    return (
      <Card className="p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-6">Ride Statistics</h2>
        <div className="text-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-pink-600 mx-auto"></div>
        </div>
      </Card>
    );
  }

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-6">Ride Statistics</h2>
      <div className="grid grid-cols-3 gap-4">
        <div className="text-center p-4 bg-pink-50 rounded-lg">
          <div className="text-3xl font-bold text-pink-600">{stats.total}</div>
          <div className="text-sm text-gray-600 mt-1">Total Rides</div>
        </div>
        <div className="text-center p-4 bg-purple-50 rounded-lg">
          <div className="text-3xl font-bold text-purple-600">{stats.thisMonth}</div>
          <div className="text-sm text-gray-600 mt-1">This Month</div>
        </div>
        <div className="text-center p-4 bg-blue-50 rounded-lg">
          <div className="text-3xl font-bold text-blue-600">K{stats.totalSpent}</div>
          <div className="text-sm text-gray-600 mt-1">Total Spent</div>
        </div>
      </div>
    </Card>
  );
};

export default RideStats;
